import * as React from 'react'
import ErrorMessages from 'javascripts/common/ErrorMessages'

interface JobApplicationModalContentProps {
  errors: string[];
  closeModal: VoidFunction;
  handleSaving: boolean;
  handleSaveClicked: VoidFunction;
  jobOfferTitle: string;
}

export default class JobApplicationModalContent extends React.Component<JobApplicationModalContentProps, never> {
  render_submit_button() {
    if (this.props.handleSaving) return <div className="loading_lg text-center"/>

    return (
      <button disabled={this.props.handleSaving} type="button" className="job-btn -green btn-tech-primary btn-block" onClick={this.props.handleSaveClicked}>
        応募する
      </button>
    )
  }

  render() {
    return (
      <>
        <button aria-label="Close" className="modal-close" data-bs-dismiss="modal" type="button" onClick={this.props.closeModal} />
        <div className="modal-header">
          <h6 className="modal-title">{this.props.jobOfferTitle}</h6>
        </div>
        <div className="modal-body">
          <ErrorMessages messages={this.props.errors}/>
          <p>このお仕事に本当に応募しますか。</p>
        </div>
        <div className="modal-footer">
          <button disabled={this.props.handleSaving} type="button" className="job-btn -gray btn-secondary" onClick={this.props.closeModal}>
            キャンセル
          </button>
          {this.render_submit_button()}
        </div>
      </>
    )
  }
}
